import { Component, Input } from '@angular/core';

import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
    selector: 'app-header-and-menu',
    templateUrl: './header-and-menu.component.html',
    styleUrls: ['./header-and-menu.component.scss'],
})
export class HeaderAndMenuComponent {
    @Input() sidenav!: MatSidenav;
    @Input() set openMenu(value: boolean) {
        this._openMenu = value;
    }

    _openMenu!: boolean;
    get getMatSidenav(): boolean {
        return this._openMenu;
    }
    constructor(private authService: AuthService) {}

    logout() {
        this.authService.signOut();
    }
}
